import { all, call, delay, put, select } from 'redux-saga/effects';
import LocalStorageService from '@services/localStorage';
import api from '@services/api';
import { AdminTypes } from '@adapters/redux/reducer/admin';
import { FAKE_DATA } from '@services/constant';

export function* getAllPages() {
  try {
    const responses = yield all([
      call(getData, 'homepage', 'homePage'),
      call(getData, 'owner', 'ownerInfo'),
      call(getData, 'contact-us', 'contactUs'),
      call(getData, 'page/rooms', 'rooms'),
      call(getData, 'offers', 'offers'),
      call(getData, 'destinations', 'destinations'),
      call(getData, 'meeting-event', 'events'),
      call(getData, 'subscribers', 'subscribers'),
      call(getData, 'comments', 'comments'),
      call(getData, 'spas', 'spas'),
      call(getData, 'dinnings', 'dinnings'),
      call(getData, 'experiences', 'experiences'),
      call(getData, 'galleries', 'galleries'),
      call(getData, 'auth/accounts', 'accounts'),
    ]);
    const flatResponses = responses.flat();
    const data = flatResponses.reduce((obj, item) => {
      return Object.assign(obj, { [item.field]: item.response });
    }, {});
    yield put({
      type: AdminTypes.GET_PAGES_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(
      'Debug ~ file: index.js:32 ~ function*getAllPages ~ error:',
      error
    );
  }
}

export function* getData(url, field) {
  try {
    const response = yield call(api.fetchPageData, url);
    switch (field) {
      case 'rooms':
        return { field, response: response[field] };
      case 'homePage':
        return [
          { field: 'homePage', response },
          { field: 'comments', response: response.comments },
          { field: 'intro_section', response: response.intro_section },
          { field: 'video_banner', response: response.video_banner },
          { field: 'section1', response: response.section1 },
          { field: 'section2', response: response.section2 },
          { field: 'section3', response: response.section3 },
          { field: 'experience_intro', response: response.experience },
        ];
      case 'contactUs':
        return [
          { field: 'contactUs', response },
          { field: 'subscribe_section', response: response.subscribe_section },
        ];
      case 'aboutUs':
        return [
          { field: 'aboutUs', response },
          { field: 'section1', response: response.section1 },
          { field: 'section2', response: response.section2 },
          { field: 'section3', response: response.section3 },
        ];
      default:
        return { field, response };
    }
  } catch (error) {
    console.log(`Get page ${url} error: ${error.message}`);
    switch (field) {
      case 'rooms':
      case 'offers':
      case 'destinations':
      case 'accounts':
        return { field, response: FAKE_DATA[field] || [] };
      case 'homePage':
        return [
          { field: 'homePage', response: FAKE_DATA.homePage },
          { field: 'comments', response: FAKE_DATA.comments || [] },
          { field: 'intro_section', response: FAKE_DATA.intro_section },
          { field: 'video_banner', response: FAKE_DATA.video_banner },
          { field: 'section1', response: FAKE_DATA.section1 },
          { field: 'section2', response: FAKE_DATA.section2 },
          { field: 'section3', response: FAKE_DATA.section3 },
          { field: 'experience_intro', response: FAKE_DATA.experience_intro },
        ];
      case 'contactUs':
        return [
          { field: 'contactUs', response: FAKE_DATA.contactUs },
          { field: 'subscribe_section', response: FAKE_DATA.subscribe_section },
        ];
      case 'aboutUs':
        return [
          { field: 'aboutUs', response: FAKE_DATA.aboutUs },
          { field: 'section1', response: FAKE_DATA.section1 },
          { field: 'section2', response: FAKE_DATA.section2 },
          { field: 'section3', response: FAKE_DATA.section3 },
        ];
      default:
        return { field, response: FAKE_DATA[field] };
    }
  }
}

export function* updateData({ method, url, params, field, callback }) {
  try {
    const state = yield select((state) => state.admin);

    const images = params.images;

    delete params.images;

    let response;

    if (method === 'post') {
      response = yield call(api.createData, url, params);
    } else {
      response = yield call(api.updateData, url, params);
    }

    if (images && images.length > 0) {
      const uploadImageResponses = yield all(
        images.map((img) => {
          const { field, image } = img;
          const { id } = response[field];
          const formData = new FormData();
          formData.append('upload', image);
          formData.append('id', id);
          return call(uploadImage, formData, img.field);
        })
      );
      uploadImageResponses.map((res) => {
        const { field, data } = res;
        response[field] = data;
      });
    }

    switch (field) {
      case 'rooms':
      case 'services':
      case 'offers':
      case 'destinations':
      case 'dinnings':
      case 'experiences':
      case 'spas':
      case 'comments':
      case 'galleries':
      case 'accounts':
      case 'events':
        const payload = state[field];

        if (method === 'post') {
          payload.push(field === 'accounts' ? response.user : response);

          yield put({
            type: AdminTypes.UPDATE_DATA_SUCCESS,
            payload: { [field]: payload },
          });
        } else {
          const payloadUpdate = payload.map((p) => {
            if (p.id !== response.id) return p;
            return response;
          });

          yield put({
            type: AdminTypes.UPDATE_DATA_SUCCESS,
            payload: { [field]: [...payloadUpdate] },
          });
        }
        break;
      default:
        yield put({
          type: AdminTypes.UPDATE_DATA_SUCCESS,
          payload: { [field]: response },
        });
    }
    callback();
  } catch (error) {
    yield put({
      type: AdminTypes.UPDATE_DATA_FAILURE,
    });
    const message =
      error?.response?.data?.message || error.message || 'Something wrong!';
    callback(true, message);
    console.log(`${field}: ${method} ${url} error: ${message}`);
  }
}

export function* deleteData({ id, url, field, callback }) {
  try {
    const state = yield select((state) => state.admin);

    yield call(api.deleteData, url);

    const payload = state[field];
    const index = payload.findIndex((f) => f.id === id);

    if (index !== -1) {
      payload.splice(index, 1);

      yield put({
        type: AdminTypes.DELETE_DATA_SUCCESS,
        payload: { [field]: [...payload] },
      });
    }
    callback();
  } catch (error) {
    yield put({
      type: AdminTypes.DELETE_DATA_FAILURE,
    });
    const message =
      error?.response?.data?.message || error.message || 'Something wrong!';
    callback(true, message);
    console.log(`${field}: delete ${url} error: ${error.message}`);
  }
}

export function* sendEmail({ params, callback }) {
  try {
    yield call(api.sendEmail, params);

    yield put({
      type: AdminTypes.SEND_EMAIL_SUCCESS,
    });

    callback();
  } catch (error) {
    yield put({
      type: AdminTypes.SEND_EMAIL_FAILURE,
    });
    const message =
      error?.response?.data?.message || error.message || 'Something wrong!';
    callback(true, message);
    console.log(`Send email error: ${error.message}`);
  }
}

export function* uploadImage(params, field) {
  try {
    const data = yield call(api.uploadImage, params);
    return { field, data };
  } catch (error) {
    console.log(`Upload image error: ${error.message}`);
    return { field, reponse: { path: null } };
  }
}

export function* uploadImageToAlbum({ params, callback }) {
  try {
    const { name, image } = params;

    const formData = new FormData();
    formData.append('upload', image);
    formData.append('name', name);

    const data = yield call(api.uploadImageToAlbum, formData);

    const galleries = yield select((state) => state.admin.galleries);
    const album = galleries.find((g) => g.name === name);

    const returnData = galleries.map((g) => {
      if (g.name !== name) return { ...g };
      return {
        ...g,
        images: [...g.images, data],
      };
    });

    yield put({
      type: AdminTypes.UPLOAD_IMAGE_TO_ALBUM_SUCCESS,
      payload: { galleries: returnData },
    });

    callback();
  } catch (error) {
    console.log(`Upload image to album error: ${error.message}`);
    yield put({
      type: AdminTypes.UPLOAD_IMAGE_TO_ALBUM_FAILURE,
    });
    const message =
      error?.response?.data?.message || error.message || 'Something wrong!';
    callback(true, message);
  }
}

export function* deleteImageFromAlbum({ params, callback }) {
  try {
    const { albumId, imageId } = params;

    yield call(api.deleteImage, imageId);

    const galleries = yield select((state) => state.admin.galleries);
    const album = galleries.find((g) => g.id === albumId);
    const imageIndex = album.images.findIndex((id) => id === imageId);
    album.images.splice(imageIndex, 1);

    yield put({
      type: AdminTypes.UPLOAD_IMAGE_TO_ALBUM_SUCCESS,
      payload: { galleries },
    });
    callback();
  } catch (error) {
    console.log(`Upload image to album error: ${error.message}`);
    const message =
      error?.response?.data?.message || error.message || 'Something wrong!';
    yield put({
      type: AdminTypes.UPLOAD_IMAGE_TO_ALBUM_FAILURE,
    });
    callback(true, message);
  }
}
